import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';

import { ProgressSpinner } from 'primereact/progressspinner';
import { Checkbox } from 'primereact/checkbox';

import { useScrollLoadingContext } from '../../Contexts/ScrollLoadingContext';
import { useAddCampaignContent } from '../../../queries';
import { setDisableBtn } from '../../../redux/Slices/Global/globalSlice';
import { formatDuration } from '../../../config/global';
import { setLastElement } from '../../../redux/Slices/scrollSlice';
import ScrollContainer from '../ScrollContainer';
import SearchInput from './SearchInput';

function AnimatedLayoutList() {
    const { t } = useTranslation();
    const addCampaignContent = useAddCampaignContent()
    const { isFetching, data, params } = useSelector((state) => state.scroll);
    const { layer, assign } = useSelector((state) => state.global);

    const lastElementRef = useRef(null);
    const dispatch = useDispatch();
    const { id } = useParams();

    const { setIds, ids } = useScrollLoadingContext();

    const onLayoutChange = (e) => {
        let selectedLayouts = [...ids];

        if (e.checked)
            selectedLayouts.push(e.value);
        else
            selectedLayouts.splice(selectedLayouts.indexOf(e.value), 1);

        setIds(selectedLayouts);
    }

    useEffect(() => {
        if (ids.length == 0) {
            dispatch(setDisableBtn(true))
        } else {
            dispatch(setDisableBtn(false))
        }
    }, [ids])

    const assignHandler = async () => {
        await addCampaignContent.mutateAsync({
            "ids_list": ids,
            "campaign_id": id,
            "layer": layer,
            "type": "layout",
        })
    }

    useEffect(() => {
        if (assign) {
            dispatch(setDisableBtn(true));
            assignHandler()
        }
    }, [assign])


    useEffect(() => {
        if (lastElementRef.current) {
            dispatch(setLastElement(lastElementRef.current));
        }
    }, [lastElementRef.current]);


    return (
        <>
            <SearchInput isDisabled={data?.length === 0} />
            <hr className="w-100 mt-0" />

            <ScrollContainer path={`/animated-layout/company`} >
                {
                    data?.length === 0 && !isFetching ?
                        isEmpty(params?.search) ?
                            <h5 className="py-5 text-center w-100">{t('addcontent.no_layouts_yet')}</h5>
                            :
                            <h5 className="py-5 text-center w-100">{t('messages.no_results')}</h5>
                        :
                        <div className="d-flex flex-column scroll_container scroll_div px-3 w-100">
                            {/* <div className="d-flex my-3 uppercase text-[12px] font-bold">
                                <div className="col-4 col-md-2"></div>
                                <div className="col-4 mx-1 text-light">Name</div>
                                <div className="col-4 mx-1 text-light">Total Duration</div>
                            </div> */}
                            <div className="popular-movies-api d-flex flex-wrap ">
                                {
                                    data?.map((item, index) => {
                                        return item.layout_duration > 0 ?
                                            <div ref={index === data?.length - 1 ? lastElementRef : null} 
                                            className={`col-12 d-flex align-items-center justify-content-between border-bottom py-2 
                                                 ${ids.indexOf(`${item.id}`) !== -1 ? "bg-gray-200" : ""}
                                                `}
                                                key={`${item.type}-${index}`} >
                                                <label htmlFor={item.id} className="col-10 col-sm-11 d-flex align-items-center ">
                                                    <div className="col-4 col-sm-2 mx-2 ">
                                                        <div className=" me-2 p-4 rounded-2 bg-secondary d-flex align-items-center justify-content-center playlist_icon_container">
                                                            <i className="fas fa-window-maximize  fs-4 text-white"></i>
                                                        </div>
                                                    </div>
                                                    <div className="col-4 mx-1 fs-6 d-flex align-items-center text-truncate">{item.title}</div>
                                                    <div className="col-4 col-md-2 col-lg-2 fs-6 text-center">
                                                        {formatDuration(item.layout_duration)}
                                                    </div>
                                                </label>
                                                <div className="col-2 col-sm-1 pe-2  flex justify-center">
                                                    <Checkbox inputId={item.id} name="media" className=' ' value={item.id} onChange={onLayoutChange} checked={ids.indexOf(`${item.id}`) !== -1} />
                                                </div>
                                            </div>
                                            :
                                            <></>
                                    })
                                }
                            </div>
                        </div>
                }
                {
                    isFetching && data?.length ?
                        <ProgressSpinner
                            className='h-[50px] w-[50px] flex justify-center items-center my-4'
                            strokeWidth="3"
                            fill="var(--surface-ground)"
                            animationDuration="30s" /> : <></>
                }
            </ScrollContainer>
        </>
    );
}

export default AnimatedLayoutList